import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import ivanb from "../../images/ivanb.jpg";
import { Footer } from "../general";
import { ModernHeader } from "../modern";

export class Empresa extends Component {
  render = () => {
    return (
      <Fragment>
        <ModernHeader />
        <div className="modern-service-page">
          {/* Hero Section */}
          <div className="modern-service-hero">
            <div className="auto-container">
              <h1 className="animate-fade-in-up">Nuestra Empresa</h1>
              <p
                className="subtitle animate-fade-in-up"
                style={{ animationDelay: "0.2s" }}
              >
                Más de 20 años de experiencia apoyando el crecimiento de las
                Pymes en Chile
              </p>
            </div>
          </div>

          {/* Company Info Section */}
          <div className="auto-container">
            <div className="modern-company-section">
              {/* About Section */}
              <div className="modern-about-section animate-fade-in-up">
                <div className="row align-items-center">
                  <div className="col-lg-6">
                    <div className="about-content">
                      <div className="section-tag">SOMOS CONTASI</div>
                      <h2>Dedicados al soporte de Pymes</h2>
                      <p>
                        Debido a los constantes cambios en el mercado, las
                        personas naturales, pequeñas y medianas empresas también
                        llamadas Pymes requieren cada vez más un apoyo y soporte
                        en asesorías tributarias y servicios contables.
                      </p>
                      <p>
                        Contasi es una empresa dedicada al soporte de las Pymes,
                        brindando soluciones constantes para que cada Pyme se
                        ocupe en aumentar cada vez más su productividad y por
                        ende su rentabilidad, dejando en manos expertas su área
                        financiera.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="about-stats">
                      <div className="stat-item">
                        <div className="stat-number">20+</div>
                        <div className="stat-label">Años de Experiencia</div>
                      </div>
                      <div className="stat-item">
                        <div className="stat-number">500+</div>
                        <div className="stat-label">Empresas Atendidas</div>
                      </div>
                      <div className="stat-item">
                        <div className="stat-number">100%</div>
                        <div className="stat-label">Satisfacción Cliente</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* CEO Section */}
              <div
                className="modern-ceo-section animate-fade-in-up"
                style={{ animationDelay: "0.3s" }}
              >
                <div className="row align-items-center">
                  <div className="col-lg-4">
                    <div className="ceo-image">
                      <img src={ivanb} alt="Ivan Bahamonde - Gerente General" />
                      <div className="ceo-overlay">
                        <div className="ceo-title">Gerente General</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="ceo-content">
                      <h3>Ivan Bahamonde</h3>
                      <h4>Gerente General</h4>
                      <div className="ceo-credentials">
                        <div className="credential-item">
                          <i className="fas fa-graduation-cap"></i>
                          <span>Ingeniero en Administración de Empresas</span>
                        </div>
                        <div className="credential-item">
                          <i className="fas fa-certificate"></i>
                          <span>
                            Diplomados en Gestión Contable y Financiera
                          </span>
                        </div>
                        <div className="credential-item">
                          <i className="fas fa-university"></i>
                          <span>
                            MBA en Economía y Finanzas - Universidad Finis
                            Terrae
                          </span>
                        </div>
                        <div className="credential-item">
                          <i className="fas fa-chalkboard-teacher"></i>
                          <span>
                            Académico en Universidad de las Américas, Inacap,
                            Instituto Guillermo Subercaseaux
                          </span>
                        </div>
                      </div>
                      <p>
                        Con amplia experiencia en Auditorías contables y
                        Financieras, Asesorías tributarias y Contabilidades en
                        general.
                      </p>
                      <p>
                        <strong>
                          Junto a nuestro equipo de colaboradores nos encargamos
                          de acompañarlos desde el comienzo de su empresa y
                          apoyarlos en sus empresas en marcha, de modo que
                          podamos en conjunto hacer crecer todos sus proyectos.
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Values Section */}
              <div
                className="modern-values-section animate-fade-in-up"
                style={{ animationDelay: "0.5s" }}
              >
                <h3>Nuestros Valores</h3>
                <div className="values-grid">
                  <div className="value-item">
                    <div className="value-icon">
                      <i className="fas fa-handshake"></i>
                    </div>
                    <h4>Confianza</h4>
                    <p>
                      Construimos relaciones sólidas basadas en la transparencia
                      y el compromiso.
                    </p>
                  </div>
                  <div className="value-item">
                    <div className="value-icon">
                      <i className="fas fa-trophy"></i>
                    </div>
                    <h4>Excelencia</h4>
                    <p>
                      Buscamos la perfección en cada servicio que brindamos a
                      nuestros clientes.
                    </p>
                  </div>
                  <div className="value-item">
                    <div className="value-icon">
                      <i className="fas fa-lightbulb"></i>
                    </div>
                    <h4>Innovación</h4>
                    <p>
                      Adoptamos nuevas tecnologías y metodologías para optimizar
                      nuestros procesos.
                    </p>
                  </div>
                  <div className="value-item">
                    <div className="value-icon">
                      <i className="fas fa-users"></i>
                    </div>
                    <h4>Compromiso</h4>
                    <p>
                      Nos dedicamos completamente al éxito y crecimiento de
                      nuestros clientes.
                    </p>
                  </div>
                </div>
              </div>

              {/* CTA Section */}
              <div
                className="modern-company-cta animate-fade-in-up"
                style={{ animationDelay: "0.7s" }}
              >
                <div className="cta-content">
                  <h3>¿Listo para hacer crecer tu empresa?</h3>
                  <p>
                    Permítenos ser tu socio estratégico en el área financiera y
                    contable
                  </p>
                  <div className="cta-buttons">
                    <Link to="/contacto" className="modern-cta-button primary">
                      Contactar
                      <i className="fas fa-arrow-right"></i>
                    </Link>
                    <a
                      href="tel:+56961922323"
                      className="modern-cta-button secondary"
                    >
                      <i className="fas fa-phone"></i>
                      +56 9 6192 2323
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </Fragment>
    );
  };
}

export default Empresa;
